var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ekitabu-image',_vm._g(_vm._b({attrs:{"src":_vm.displaySrc},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('image-loading')]},proxy:true}])},'ekitabu-image',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }